import { IconButton, IconButtonProps, styled } from "@mui/material";

interface ExpandMoreProps extends IconButtonProps {
	expand: boolean;
}

const StyledExpandMore = styled((props: ExpandMoreProps) => {
	const { expand, ...other } = props;
	void expand;
	return <IconButton {...other} />;
})(({ theme, expand }) => ({
	transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
	marginLeft: "auto",
	marginRight: "10px",
	marginBottom: expand ? "10px" : "0px",
	marginTop: expand ? "0px" : "10px",
	transition: theme.transitions.create("transform", {
		duration: theme.transitions.duration.shortest,
	}),
	width: "40px",
	height: "40px",
	alignSelf: expand ? "center" : "start",
}));

export const ExpandMore = (props: ExpandMoreProps) => {
	const { expand, ...rest } = props;

	return <StyledExpandMore expand={expand} {...rest} />;
};
